<template>
    <div>
        <ValidationObserver ref="form">
            <form>
                <div class="client-demo-card-header">
                    <h3>Extended Family List</h3>
                </div>
                <div class="client-demo general px-4 pb-2">
                    <div class="flex colx2 wrap w-full">
                        <b-table
                            :items="extendedMemberList"
                            :fields="fields"
                            class="extended-family-table"
                            :tbody-tr-class="rowClass"
                        >
                            <template #cell(name)="row">
                                <span>{{
                                    row.item.first_name && row.item.last_name
                                        ? `${row.item.first_name} ${row.item.last_name}`
                                        : '---'
                                }}</span>
                            </template>

                            <!-- <template #cell(role)="row">
                                <div class="d-flex align-items-center gap-2">
                                    <img src="@/assets/px/manage_account.svg" alt="" />
                                    <span>{{ userRole(row.item.role_id) }}</span>
                                </div>
                            </template> -->

                            <template #cell(actions)="row">
                                <button
                                    @click="openRevokeModal(row.item, true)"
                                    type="button"
                                    class="no-bg revoke-button d-flex gap-2"
                                    :disabled="row.item.is_disabled === 1"
                                >
                                    <img src="@/assets/px/cross-icon.svg" alt="" />
                                    Revoke
                                </button>
                            </template>
                        </b-table>
                    </div>
                </div>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
    import { ValidationObserver } from 'vee-validate';

    export default {
        name: 'ExtendedFamilyList',
        components: { ValidationObserver },
        props: {
            extendedMemberList: {
                type: Array,
            },
        },
        data() {
            return {
                fields: [
                    {
                        key: 'name',
                        label: 'Name',
                        tdClass: 'align-left',
                    },
                    {
                        key: 'email',
                        label: 'Email',
                        tdClass: 'align-middle lowercase',
                    },
                    // {
                    //     key: 'role',
                    //     label: 'Role',
                    //     tdClass: 'align-middle',
                    // },
                    {
                        key: 'actions',
                        label: 'Action',
                        tdClass: 'text-right align-middle',
                    },
                ],
            };
        },
        methods: {
            rowClass(item, type) {
                if (type === 'row' && item && item.is_disabled === 1) {
                    return 'disabled-row';
                }
                return '';
            },
            openRevokeModal(member, is_disabled) {
                this.$emit('revokeAccess', {
                    memberId: member.id,
                    is_disabled,
                });
            },
        },
    };
</script>

<style>
    .table thead th {
        background-color: transparent !important;
        color: #3d3d3d;
        font-size: 1rem;
        font-weight: 600;
        text-transform: none;
        cursor: default !important;
    }

    .extended-family-table {
        border-collapse: separate;
    }

    .extended-family-table tbody tr {
        background: white;
        border-radius: 12px;
        box-shadow: 0px 4px 4px 0px #0000000a;
        overflow: hidden;
    }

    .extended-family-table tbody tr td {
        cursor: default !important;
    }

    .extended-family-table tbody tr:not(:last-child) {
        margin-bottom: 10px !important;
    }

    button.no-bg:hover {
        background: none;
    }

    .revoke-button {
        color: black;
        font-size: 14px;
        font-weight: 500;
        border: none;
        border-radius: 5px;
        padding: 0;
        cursor: pointer;
    }

    .revoke-button:disabled {
        background: none !important;
    }

    .extended-family-table .disabled-row td {
        background-color: #f2f2f2 !important;
        color: gray !important;
        opacity: 0.6;
    }

    .lowercase {
        text-transform: lowercase !important;
    }
</style>
